import { Helmet } from "react-helmet";
import { 
  DocumentTextIcon,
  
} from "@heroicons/react/24/outline";

// components
import { SectionHeader } from "../../components/layouts/section.header";
import { SectionSubHeader } from "../../components/layouts/section.subheader";
import { KanbanBoardJobs } from "../../components/kanban/board.jobs";

export const ScreenDashboard = () => {

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <div className="h-screen w-full">
        <SectionHeader title='Mission Board' />

        {/* CARD SUMMARY */}
        <div className="mt-8">

          {/* TABLE CONFERENCE */}
          <div className="mt-10">

            <div className="w-full flex flex-col justify-start items-start">
              <SectionSubHeader Icon={DocumentTextIcon} title='All Orders' />

              <div className="mt-8">
                <KanbanBoardJobs />
              </div>
              
            </div>

          </div>

        </div>
      </div>
    </>
  ); 
}